import { Component, inject } from '@angular/core'
import { ActivatedRoute, RouterLink } from '@angular/router'

import { PrivacyPolicyComponent } from 'app/pages/privacy-policy/privacy-policy.component'
import { TermsAndConditionsComponent } from 'app/pages/terms-and-conditions/terms-and-conditions.component'

@Component({
  selector: 'app-private-legal',
  imports: [RouterLink, PrivacyPolicyComponent, TermsAndConditionsComponent],
  templateUrl: './private-legal.component.html',
  styleUrl: './private-legal.component.scss'
})
export class PrivateLegalComponent {
  legalPage = inject(ActivatedRoute).snapshot.data['legalPage'] as
    | 'privacy-policy'
    | 'terms-and-conditions'
}
